const articleHero = document.querySelector('[data-article-hero]')
const articleHeroHeight = articleHero ? articleHero.offsetHeight : null
const articleSecondaryNav = document.querySelector(
  '[data-article-secondary-navigation]'
)

if (articleSecondaryNav && articleHeroHeight) {
  document.addEventListener('scroll', () => {
    Math.round(window.pageYOffset >= articleHeroHeight)
      ? articleSecondaryNav.classList.add('--is-visible')
      : articleSecondaryNav.classList.remove('--is-visible')
  })
}
